import React from "react";

export default class FontW7 extends React.Component {
    render() {
        const { children, className = ''} = this.props
        return (
            <span className={`font-han-sans-w7 ${className}`}>
                {children}
            </span>
        );
    }
}
